import { generateId } from "@msuite/utils/strings";
import { View } from "@react-pdf/renderer";
import clsx from "clsx";
import React from "react";
import { Spacer } from "../spacer";
import { tw } from "../tailwind";
import { Text } from "../text";
import type { MetaItem } from "../types";

/** Props Interface */
interface MetaProps {
	items: MetaItem[];
}

export function Meta({ items }: MetaProps) {
	return (
		<React.Fragment>
			<View
				fixed
				wrap={false}
			>
				<Spacer />
				<View style={tw("flex flex-row")}>
					{items.map((item, index) => {
						const isFirst = index === 0;
						const isLast = index === items.length - 1;
						const alignRight = isLast && !isFirst;

						/** Render */
						return (
							<View
								style={tw(clsx("flex-1", alignRight ? "items-end" : "items-start"))}
								key={generateId()}
							>
								<Text style={tw("text-xs")}>{item.label}</Text>
								{item.values.map((value) => (
									<Text
										monospace={item.valuesMonospace}
										key={value}
									>
										{value}
									</Text>
								))}
							</View>
						);
					})}
				</View>
				<Spacer />
			</View>
		</React.Fragment>
	);
}
